import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild, isDevMode} from '@angular/core';
import {DemoService} from '../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../../services/mysql.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map, Subscription} from 'rxjs';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import {SystemFile} from './../../../../shared/models/file.model';

// Environmental Variables
import { environment } from './../../../../../environments/environment';
import { DatePicker } from '@syncfusion/ej2-angular-calendars';
import { GridComponent, SearchSettingsModel, FilterSettingsModel, IFilter, ToolbarItems, GroupSettingsModel, IFilterUI } from '@syncfusion/ej2-angular-grids';
import { RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
  import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
  import { DataManager  } from '@syncfusion/ej2-data';
import { SubjectNote } from 'src/app/api/subjectNote';


import { DateAgoPipe } from './../../../../pipes/date-ago.pipe';
import { DomSanitizer } from '@angular/platform-browser';
import { Permission } from 'src/app/shared/models/permission.model';
import { LegalDateTimeService } from './../../../../services/legal-datetime.service';



@Component({
  selector: 'app-note-edit-widget',
  templateUrl: './note-edit-widget.component.html',
  styleUrls: ['./note-edit-widget.component.scss']
})
export class NoteEditWidgetComponent implements OnInit {

  @Input() subject_id: number;
  @Input() job_id: any;

  @Input() file_id?: Observable<any[]>;
  @Input() file_data?: any;
  @Input() permission_check?: boolean;
  file: SystemFile;
  note: SubjectNote;



   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '';
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full | info
  returned_file_data: Object;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  
  agent_array: any;
  show_agents: any;
  assigned_to_subjects: any;
  files_assigned_from: any;
  files_assigned_from2: any;
  assigned_to_agents: any;

 
  permission_model: Permission;
  // @ViewChild('grid')
  @ViewChild('grid') public gridObj: GridComponent;
  public grid: GridComponent;
  public searchOptions: SearchSettingsModel;
 
  public pageSettings: Object;
  public pageOptions = { pageSize: 20 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: any;
  // public filterOptions: FilterSettingsModel;
  public filter: IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  initialPage: { pageSize: number; };
  dateFormat: string;
  files: any;

  bsModalRef: BsModalRef;
  modalRef: BsModalRef;

  assignedAgentsList: Object;
  allRecipients = []; // collection of subjects as note recipients 
  allAgentsAssigned: any[];
  agent_access_array: any;
  report_access_array: any;
  invoice_access_array: any;
  user_access_array: any;
  del_files: Object;
  note_data: any;
  system_note_data: any;
  note_id: any;
  notes_assigned_from: any;
  notes_assigned_from2: string;
  model: SubjectNote;



  selected_value: any[];

  list : any[];
  list_selected : any[];
  results: any[];
  sub_assigned_to_subjects: any;
  list_a: any[];
  system_log_created_response: any;
  file_created_response: any;
  file_edit_level: string;
  created_file_name: any;
  current_subject_data: any;
  returned_created_file_id: any;

  sessionUserLevel: any;
  allAgentRecipients: any[];
  assignedAgentsList2: any;
  brand_types_data: any;
  job: Object;
  brand_report_id: any;

  note_created_response: any;
  returned_created_note_id: any;
  job_subject_data: Object;
  selected_file_number: any;
  selected_file_subject_number: any;

  // @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  job_subjects_data: Object;


   // Text editor Settings
   public simpleToolBar: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo',
    // {
    //   tooltipText: 'Insert Promotion',
    //   undo: true,
    //   click: this.onClickPromotionButton.bind(this),
    //   template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
    // }
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    };
    public pasteCleanupSettings: object = {
      prompt: true,
      plainText: false,
      keepFormat: false,
      deniedTags: ['a'],
      deniedAttrs: ['class', 'title', 'id'],
      allowedStyleProps: ['color', 'margin', 'font-size']
  }; 
  brand_types: any;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService,
    private sanitizer: DomSanitizer,
    public legalDate: LegalDateTimeService



  ) {
// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

        // Setup Grid
        this.toolbarOptions = []; 

        // this.toolbarOptions = ['Search'];
        // this.toolbarOptions = ['ExcelExport', 'Search'];

        // this.toolbar = [
        // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];
      //  this.initialPage = { pageSize: 100 };
        this.filterOptions = {
          type: 'Menu'
        };
        this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
        this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
        this.dateFormat = 'dd/MM/yyyy hh:mm a';
        this.filter = { params: { format: this.dateFormat } };


   }



      // check for changes. to load data.
      ngOnChanges(changes) {

        this.model = new SubjectNote();
   
        
// load permissions
          // set the form vars and permissions for change
          this.getBrandTypes();
          this.permission_model = new Permission();
          this.permission_model = {
            job_id: this.job_id,
            subject_id: this.subject_id, // this will be blank
            created_by: this.gfunc.sessionUserId,
            created_level: this.gfunc.sessionUserLevel,
            file_brand_id: this.gfunc.sessionBrandId,
            brand_type_id: this.gfunc.sessionBrandTypeId,
            assigned_to_agents: JSON.stringify(this.allAgentRecipients)
            } as Permission;




        if(this.job_id >= 1){
          this.getJob(this.job_id);
          }
           // this.getSubjectNotes(this.subject_id);
          
          // this.getSubjectNotesProgression(this.job_id, this.file_number);
          if (this.subject_id >= 1) {
           console.log('Subject Detected: ' + this.subject_id);
          this.getJobSubject(this.subject_id);
          this.getSubjectAgentBrandsAssigned(this.subject_id); // load the agents to array ready for agent note
          }
          this.getBrandTypes();
        

        if (changes.item_id) {
          // deal with asynchronous Observable result
          // this.file_id = changes.item_id.currentValue;
          this.note_id = changes.item_id.currentValue;

              // load data from sent ID
              if (!this.note_data){
                this.getSystemNote(this.note_id);
                // this.getSystemNoteAssignedFrom(this.note_id); // assigned files if data was passed // moved to function above.
              }else{
             // this.file_data = this.returned_file_data;

  
              }
        }
      }

  ngOnInit() {

    if (isDevMode()) {
      console.log('Development!');
      console.log('fileURL: ', environment.$fileURL);
    } else {
      console.log('Production!');
    }

  }







  getSystemNote(note_id){
    this._demoService.getSystemNote(note_id).subscribe(
       data => { 
         this.note_data = data;
         this.system_note_data = data;
         let res = data[0];
   
       // see how this loads for the drop down.(multiselect)
        this.model.assigned_to_subjects = res.assigned_to_subjects;
            
        
        this.getSystemNoteAssignedFrom(note_id); // assigned files if data was passed

       // this.model.assigned_to_subjects = JSON.parse(res.assigned_to_subjects);// joins comma with a space
      //  console.log(this.model.assigned_to_subjects);
      
     this.getJobSubjects(res.job_id); // subjects drop downs.
     this.getJob(res.job_id); // sets the file_brand_id.
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
    }




    getSystemNoteAssignedFrom(note_id){
      this._demoService.getSystemNoteAssignedFrom(note_id).subscribe(
         data => { this.notes_assigned_from = data;
        let res = data[0];
        this.notes_assigned_from2 = JSON.stringify(this.notes_assigned_from);
        
console.log('Notes Assigned: ', this.notes_assigned_from2);

        },
         err => console.log(err),
         // () => console.log('done loading Trace Types')
       );
      }

 






              getJobSubjects(job_id){
                this.list_a = [];
                this.list_selected = [];
                this._demoService.getJobSubjects(job_id).subscribe(
                   data => { 
                     this.job_subjects_data = data;
                    let res_data = data;
                    
                     // setup new mulit-select- list
                     let newArr = data
                     let  count_of_items = Object.keys(newArr).length;
                     for(let i=0;i < count_of_items; i++) {
                      let res = newArr[i];
                      this.list_a.push({
                        name: res.subject_number,
                        checked: false,
                          });
                       this.list_a = this.list_a;
                     } // end for
              
                        // saved cell in file to hold assigned to subject records.
                        // json passed to remove all escaped chars and turn into JSON object again
                    let newArr2 = JSON.parse(this.model.assigned_to_subjects);
                    console.log('pased JSOB selected array: ' + newArr2);
                   //  let newArrPassed = JSON.parse(JSON.stringify(this.model.assigned_to_subjects));
              
                    let  count_of_selected_items = newArr2.length;
                     console.log('Count of Selcted items: ' + count_of_selected_items);
                     for(let i=0; i < count_of_selected_items; i++) {
                      let res2 = newArr2[i];
                      this.list_selected.push({
                        name: res2.name,
                        checked: res2.checked,
                          });
                     //  this.list_selected = this.list_selected;
                     } // end for
              
                     console.log(this.list_selected);
              
                     // merge two data sets together with reduce fnction
                    this.results = [...this.list_selected, ...this.list_a];
                    const test_var = [...this.list_selected, ...this.list_a ];
              
                     // now need to work out how to merge the two together.
                     // find unique's based upon name.
                  // this.results.filter((v,i,a)=>a.findIndex(t=>(t.name === v.name))===i);
                  // arr.filter((v,i,a)=>a.findIndex(t=>(t.place === v.place && t.name===v.name))===i)
              
                  // function removes duplicates in an array.
                  // commented out below for testing.
              //     var uniqueArray = this.removeDuplicates(this.results, "name");
                 // console.log("uniqueArray is: " + JSON.stringify(uniqueArray));
              
                  var uniqueArray2 = test_var.filter((v,i,a)=>a.findIndex(t=>(t.name === v.name))===i);
                  console.log("uniqueArra2y is: " + JSON.stringify(uniqueArray2));
              
                  this.results = uniqueArray2;
                  this.list = this.results;
              
              //    console.log('filtered Results: ' + JSON.stringify(this.results));
              //    console.log('filtered List: ' + JSON.stringify(this.list));
              
                  },
                   err => console.error(err),
                   // () => console.log('done loading Trace Types')
                 );
                }
              
              
              // :: Memoves all duplicates in a functional array 
              // :; @ https://www.codegrepper.com/code-examples/typescript/remove+duplicate+objects+based+on+id+from+array+angular+8
              removeDuplicates(originalArray, prop) {
                  var newArray = [];
                  var lookupObject  = {};
              
                  for(var i in originalArray) {
                     lookupObject[originalArray[i][prop]] = originalArray[i];
                  }
              
                  for(i in lookupObject) {
                      newArray.push(lookupObject[i]);
                  }
                   return newArray;
              }
              
              
              
              
                getJobSubject(subject_id){  
                  this._demoService.getJobSubject(subject_id).subscribe(
                  data => { 
                    this.job_subject_data = data;
                    let res = data[0]
                    this.selected_file_number = res.file_number;
                    this.selected_file_subject_number = res.subject_number;
                    // I need to turn the string back into an object before iliterating through
                    // JSON.stringify(str) --> JSON.parse(str)
                 },
                  err => console.error(err),
                  // () => console.log('done loading Trace Types')
                );
               }
              
              
               getJob(job_id) {
                this._demoService.getJobID(job_id).subscribe(
                   data => { this.job = data;
                    let res = data[0];
                    // Run the job data queries.
                  //   this.job_type_id = res.job_type_id;
                  this.brand_report_id = res.brand_report_id;
                  //       // naming
                  //  this.getJobType(res.job_type_id);
                  //  this.getJobTypeLocation(res.job_type_location_id);
                  //  this.getJobTypeCourt(res.job_type_court_id);
                  },
                   err => console.error(err),
                   // () => console.log('done loading Trace Types')
                 );
               };
              
              
              
              
              
              
              // need to change this below
              updateSystemFile(model) {
              // model.job_id = this.job_id;
              model.selected_file_number = this.selected_file_number;
              model.selected_file_subject_number = this.selected_file_subject_number;
              
               this._demoService.updateFile(model).subscribe(
              
                data => { // this.trace_candidate_update = data;
                  // refresh the list
                 // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
              //   this.toastr.success('System File Assigned');
              //  this.createJobSubjectsMultiple(model);
                // Subject to reload the manager component parent.
               // TraceCandidateManagerComponent.returned.next(false);
              // this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);
              // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);
              // this.closeParentModel.emit();
                          return true;
                },
                // error => {
                //  // console.error('Error saving Event!');
                //   this.toastr.error('Error saving Document!');
                //   return Observable.throw(error);
                // },
                err => console.error(err),
                () => console.log('done updates')
              );
              }
      

























  getSystemFile(file_id){

    this.show_agents = [];
    this._demoService.getSystemFile(file_id).subscribe(
       data => { this.file_data = data;
      let res = data[0];
      

      // Agent Permissions and Arrays Setups - agents linked to the subject if a subject file. and Agent Level Access
   // load the agent Permissions (assinged_to_agents ) - on create file

   
   this.getSubjectAgentBrandsAssigned(res.file_subject_id);
   
   this.agent_access_array = JSON.parse(res.agent_access_array);
   this.report_access_array = JSON.parse(res.report_access_array);
   this.invoice_access_array = JSON.parse(res.invoice_access_array);
   this.user_access_array = JSON.parse(res.user_access_array);

    this.assigned_to_subjects = JSON.stringify(res.assigned_to_subjects);
      this.assigned_to_agents = JSON.stringify(res.assigned_to_agents);

      // array for agents display test may not be correct if other agents?
let newArrA = res;
//  let  count_of_items = Object.keys(newArrA).length;
let  count_of_items = Object.keys(newArrA).length;
   // need to do a loop of subject_billing items (.length)
   for(let i=0;i < count_of_items; i++) {
   let res22 = newArrA[i];

   // just grabs the first agent. // as pass was throwing errors. // end of json.

   // this.agent_array = JSON.parse(res22.assigned_to_agents);
   

 

//    this.show_agents.push({
//      recipient_name: res22.recipient_name + '',
//      recipient_email_address: newArrA[i].recipient_email_address,
//      recipient_brand_id: res22.recipient_brand_id,
//      recipient_subject_id: res22.subject_id,
//      recipient_brand_type_id: res22.brand_type_id,
//      recipient_user_id: null,
//      recipient_user_level_id: null,
//      recipient_type_name: res22.recipient_type_name,
//    });
   } // end for loop
//  this.show_agents = this.show_agents; // ?? this may be causing errors.
// console.log(JSON.stringify(this.agent_array));

this.show_agents = this.agent_array; // ?? this may be causing errors.
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
    }



    getSystemFileAssignedFrom(file_id){
      this._demoService.getSystemFileAssignedFrom(file_id).subscribe(
         data => { this.files_assigned_from = data;
        let res = data[0];
        this.files_assigned_from2 = JSON.stringify(this.files_assigned_from);
        
console.log('Files Assigned: ', this.files_assigned_from2);

        },
         err => console.log(err),
         // () => console.log('done loading Trace Types')
       );
      }

    editSystemFile(file_id) {
      // this.router.navigate(['/admin/system-file-manager/system-file-edit/' + file_id + '']);
      this.gfunc.globalEditSystemFile(file_id);
    }







// nSome grid functions

toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}


clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.files }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);
    
   // this.search_results = pdfdata.records; // need this if a grouping is set.
/*     this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

}


// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}


// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  // this.refreshGrid();
  this.modalRef.hide();
 
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div

// :: Reloads the email list


};



// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned(subject_id) {
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
       this.allRecipients = this.allRecipients; // ?? this may be causing errors.
       // set records to send to subject_notes data table

       // if an agent posting
       if(this.gfunc.sessionUserLevel === 5) {
       this.RemoveElementOthersFromAllRecipients(this.gfunc.sessionBrandId);
       };


       this.model.assigned_to_agents = JSON.stringify(this.allRecipients);

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }

 RemoveElementOthersFromAllRecipients(key: number) {
  // test! -- load again an then filter and create the array again.
  // this.getSubjectAgentBrandsAssigned2(this.subject_id); // load first then remove. safest option.

  // delay load slightly so I can refresh the allRecpientList first.
  setTimeout(function() {   
}, 2000);
    // console.log("Ready to clean array!")

  let array = this.allRecipients;
  // removes all not matching
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array
    this.allRecipients.forEach((value, index) => {
    if (value.recipient_brand_id !== key) {
      this.allRecipients.splice(index, 1);
    }
  }
  );
  // console.log('Recipients after Removal Others: ', JSON.stringify(this.allRecipients));

// ::@https://stackoverflow.com/questions/5310304/remove-json-element
// let json = this.allRecipients
// let id_key = "recipient_brand_id";
// delete json[id_key]; // Removes json.foo from the dictionary.

this.model.assigned_to_agents = JSON.stringify(this.allRecipients);

};




RemoveElementFromAllRecipients(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allRecipients.forEach((value, index) => {
    if (value.recipient_name === key) {
      this.allRecipients.splice(index, 1);
    }
  });
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};



// :: Method to all default recipients
setAllRecipients(model) {
  this.allRecipients = [];

if (model.send_to_report == 1) {
  // 
        // :: Impliments automatic recipients based on chosen com template options
        // :: Subract Method / Filter
        // :: DEMOSERVICE look up client brand details.
        this._demoService.getBrandById(model.brand_report_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
               recipient_name: res.name + ' - Client Report',
               recipient_email_address: res.email,
               recipient_brand_id: res.brand_id,
               recipient_brand_type_id: res.brand_type_id,
               recipient_user_id: null,
               recipient_user_level_id: null,
               recipient_type_name: 'Client Report',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          // () => console.log('Client Report Recipient Added.')
        );

    } // end if send_to_report
      
    // AGENT
    if ( model.brand_type_id == 3) { 
      this._demoService.getSubjectAgentBrandsAssigned(model.subject_id).subscribe(
        (data) => {
          // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
         let newArr = data;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
           this.allRecipients.push({
             recipient_name: res.name + ' - Agent',
             recipient_email_address: res.email,
             recipient_brand_id: res.brand_id,
             recipient_brand_type_id: res.brand_type_id,
             recipient_user_id: null,
             recipient_user_level_id: null,
             recipient_type_name: 'Agent',
           });
           } // end for loop
         this.allRecipients = this.allRecipients; // ?? this may be causing errors.

        },
        (err) => console.error(err),
        // () => console.log('Agent Recipients Added.')
      );
      // const key = 'Agent';
      // this.allRecipients.forEach((value, index) => {
      //   if (value.recipient_type_name === key) {
      //     this.allRecipients.splice(index, 1);
      //     console.log('Removed Agent Recipients');
      //   }
      // });
    };

    if (model.send_to_report_user == 1) {

      this._demoService.getUsersById(model.brand_report_user_id).subscribe(
        (data) => {
          // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
         let newArr = data;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
           this.allRecipients.push({
          recipient_name: res.first_name +  ' ' + res.surname + ' - Client Report User',
          recipient_email_address: res.email_address,
          recipient_brand_id: null,
          recipient_brand_type_id: null,
          recipient_user_id: res.user_id,
          recipient_user_level_id: res.access_level,
          recipient_type_name: 'Client Report User',
           });
           } // end for loop
         this.allRecipients = this.allRecipients; // ?? this may be causing errors.

        },
        (err) => console.error(err),
        // () => console.log('Client Report User Recipient Added.')
      );
      // const key = 'Client Report User';
      // this.allRecipients.forEach((value, index) => {
      //   if (value.recipient_type_name === key) {
      //     this.allRecipients.splice(index, 1);
      //     console.log('Removed Report User Recipient');
      //   }
      // });
    };

    if (model.send_to_invoice == 1) {
        this._demoService.getBrandById(model.brand_invoice_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
               recipient_name: res.name + ' - Client Accounts',
               recipient_email_address: res.email,
               recipient_brand_id: res.brand_id,
               recipient_brand_type_id: res.brand_type_id,
               recipient_user_id: null,
               recipient_user_level_id: null,
               recipient_type_name: 'Client Accounts',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          // () => console.log('Client Accounts Recipient Added.')
        );
    }

    if (model.send_to_logins == 1) {
      this._demoService.getBrandUsers(model.brand_report_id).subscribe(
        (data) => {
          // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
         let newArr = data;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
           this.allRecipients.push({
          recipient_name: res.first_name +  ' ' + res.surname + ' - Client User',
          recipient_email_address: res.email_address,
          recipient_brand_id: null,
          recipient_brand_type_id: null,
          recipient_user_id: res.user_id,
          recipient_user_level_id: res.access_level,
          recipient_type_name: 'Client User',
           });
           } // end for loop
         this.allRecipients = this.allRecipients; // ?? this may be causing errors.

        },
        (err) => console.error(err),
        // () => console.log('Client User Recipient Added.')
      );
      // const key = 'Client User';
      // this.allRecipients.forEach((value, index) => {
      //   if (value.recipient_type_name === key) {
      //     this.allRecipients.splice(index, 1);
      //     console.log('Removed Client User Recipients');
      //   }
      // });
    }

    if (model.send_to_primary == 1) {
      this._demoService.getBrandPrimaryContact(model.brand_report_id).subscribe(
        (data) => {
          // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
         let newArr = data;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
           this.allRecipients.push({
          recipient_name: res.first_name +  ' ' + res.surname + ' - Client Primary Contact',
          recipient_email_address: res.email_address,
          recipient_brand_id: null,
          recipient_brand_type_id: null,
          recipient_user_id: res.user_id,
          recipient_user_level_id: res.access_level,
          recipient_type_name: 'Client Primary Contact',
           });
           } // end for loop
         this.allRecipients = this.allRecipients; // ?? this may be causing errors.


        },
        (err) => console.error(err),
        // () => console.log('Client Primary Contact Added.')
      );
     
     
      // const key = 'Primary Contact';
      // this.allRecipients.forEach((value, index) => {
      //   if (value.recipient_type_name === key) {
      //     this.allRecipients.splice(index, 1);
      //     console.log('Removed Primary Contact Recipient');
      //   }
      // });
    }

} // end function




// need to get all associated agents of the job and push thier information to array
// getSubjectAgentBrandsAssigned(subject_id) {
//   this.allAgentsAssigned = [];
//   this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
//      data => { 
//        this.assignedAgentsList = data;

//        let newArr = data;
//        let  count_of_items = Object.keys(newArr).length;
//          // need to do a loop of subject_billing items (.length)
//          for(let i=0;i < count_of_items; i++) {
//          let res = newArr[i];
//          this.allAgentsAssigned.push({
//            recipient_name: res.name + '',
//            recipient_email_address: res.email,
//            recipient_brand_id: res.brand_id,
//            recipient_subject_id: res.subject_id,
//            recipient_brand_type_id: res.brand_type_id,
//            recipient_user_id: null,
//            recipient_user_level_id: null,
//            recipient_type_name: 'Agent',
//          });
//          } // end for loop
//        this.allAgentsAssigned = this.allAgentsAssigned; // ?? this may be causing errors.

//        // do an array compaire and remove if not the same.
       
//        // set records to send to subject_notes data table
//       // this.model.assigned_to_agents  = JSON.stringify(this.allRecipients);

//     },
//      err => console.error(err),
//      // () => console.log('Loaded Assigned Agents Loaded.')
//    );
//  }


 RemoveElementFromAllAgentsAssigned(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allAgentsAssigned.forEach((value, index) => {
    if (value.recipient_name === key) {
      this.allAgentsAssigned.splice(index, 1);
    }
  });

  // now reset the edit form value
         // set records to send to subject_notes data table
        //  JSON.parse();
 // this.model.assigned_to_agents = JSON.stringify(this.allAgentsAssigned);


    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};





deleteSystemFileAssigned(model){
  this._demoService.deleteSystemFileAssigned(model).subscribe(
    (res) => (
      this.del_files = res,
      console.log('Assigned Files deleted', model.file_id + ' ' + model.full_file_name),
      // this.files_table = this.files.slice(0, 10)
      this.toastr.success( "Assigned/Shared File Records Removed")
      ),
    (err) => console.error(err.status)
  );
}

deleteSystemFile(model){
  if (confirm('Are you sure you want to delete this file assign/share record, master file will remain? ')) {
  this._demoService.deleteSystemFile(model).subscribe(
    (res) => (
      this.del_files = res,
      console.log('File deleted', model.file_id + ' ' + model.full_file_name),
      // this.files_table = this.files.slice(0, 10)
      this.toastr.success( "Assigned/Shared File Record Removed"),
      this.getSystemFileAssignedFrom(this.file_id),
      this.getSystemFile(this.file_id), // refresh the lot.
      this.grid.refresh() 
      // this.refreshGrid()
      ),
    (err) => console.error(err.status)
  );
    }
}



// this deletes the lot!
deleteSystemJobFile(model) {
  console.log('FileID: ', model.file_id);
  if (confirm('Are you sure you want to delete this file, data and associations from the system? ')) {
  // change into a subscruption and delete the file action.
// 1: delete from database + Log action
this.deleteSystemFileAssigned(model);
// 2: Delete file from server
this.deleteSystemFile(model);
// logg the process
this.gfunc.insertLog_DeleteSystemFile(model);
// 3: Delete the pysical file from the server file
if (model.file_server_location !== '') {
this.deleteJobFileAny(model.full_file_name, model.file_job_id, model.file_make, model.file_server_location);
console.log('physicalFILEdelete active: ');
// find out what type of tile it is and then detete the file.
}
console.log('Success: Data + File deleted', model.file_id + ' ' + model.full_file_name);
// this.refreshGrid();
  // this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
 // this.gfunc.globalViewSystemFile(file_id);


  } // end confirm
}


// New delete any job or subject file fuction - Beta Testing
deleteJobFileAny(filename, job_id, file_make, file_server_location) {
  // if (confirm('Are you sure you want to delete this file? ')) {
    this._mysqlService.deleteJobFileAny(filename, job_id, file_make, file_server_location).subscribe(
       data => {
         // this.getTraceNotes(this.trace_id);
        // this.refreshGrid();
         return true;
       },
       error => {
         console.error('Error deleting Job File!');
        //  return Observable.throw(error);
       }
    );
// }
}



editDocFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-doc-edit/' + file_id + '']);
  this.gfunc.globalEditDocFile(file_id);
}


editDocxSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
  this.gfunc.globalEditDocxSystemFile(file_id);
}

editDocxSystemFileHTML(file_id) {
  this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit-html/' + file_id + '']);
}



viewDocxSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-view/' + file_id + '']);
  this.gfunc.globalViewDocxSystemFile(file_id);
}

viewDocxSystemFileHTML(file_id) {
  this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-view-html/' + file_id + '']);
}

subjectEditLink(subject_id) { 
  // this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
this.gfunc.globalJobSubjectViewSkipRoute(subject_id);
}


viewSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
  this.gfunc.globalViewSystemFile(file_id);
}


refreshGrid(){ // refresh the databutton
  // this.getFiles();
  this.getSystemNote(this.note_id);
   this.grid.refresh();
 };


   // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
   getHtml(html){
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
 



  getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
      //  // () => console.log('done loading candidate for update')
     );
   }





// Need to upgrade to do a loop for agents to get the items live.
shareCheckedList(item:any[]){
  console.log('many: ', item);
  // load the agent secirty array on click - only grabs one on mutile
  let  count_of_items = Object.keys(item).length;
  console.log('count of items: ', count_of_items);
  for(let i = 0; i < count_of_items; i++) {
   let res = item[i];
  this.getSubjectAgentBrandsAssigned_bySubjectNumber(item[i]); // the subject number ;
  }

  };

  shareIndividualCheckedList(item:{}) {
  console.log(item);
  // load the agent secirty array on click (Runs in the above function)
  // this.getSubjectAgentBrandsAssigned_bySubjectNumber(item[0]); // the subject number ;
  };
  



// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned_bySubjectNumber(subject_number) {

  this.allAgentRecipients = []; // empty first
  
  this._demoService.getSubjectAgentBrandsAssigned_bySubjectNumber(subject_number).subscribe(
   data => { 
     this.assignedAgentsList2 = data;
  
     let newArr = data;
     let  count_of_items = Object.keys(newArr).length;
       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
       let res = newArr[i];
       this.allAgentRecipients.push({
         recipient_name: res.name + '',
         recipient_email_address: res.email,
         recipient_brand_id: res.brand_id,
         recipient_subject_id: res.subject_id,
         recipient_brand_type_id: res.brand_type_id,
         recipient_user_id: null,
         recipient_user_level_id: null,
         recipient_type_name: 'Agent',
       });
       } // end for loop
    //  this.allAgentRecipients = this.allAgentRecipients; // ?? this may be causing errors.
     // set records to send to subject_notes data table
    //  this.model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
  
  },
   err => console.error(err),
   // () => console.log('Loaded Assigned Agents Loaded.')
  );
  }






  updateSubjectNoteContent(model) {
    // model.job_id = this.job_id;
    model.updated_by = this.gfunc.sessionUserId
    model.updated_date = this.legalDate.nowAuditIso();
    
     this._demoService.updateSubjectNoteContent(model).subscribe(
      data => { // this.trace_candidate_update = data;
        // refresh the list
       // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
    //   this.toastr.success('System File Assigned');
    //  this.createJobSubjectsMultiple(model);
      // Subject to reload the manager component parent.
     // TraceCandidateManagerComponent.returned.next(false);
    // this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);
    // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);
    // this.closeParentModel.emit();
    this.toastr.success('Note Content Updated')
                return true;
      },
      // error => {
      //  // console.error('Error saving Event!');
      //   this.toastr.error('Error saving Document!');
      //   return Observable.throw(error);
      // },
      err => console.error(err),
      () => console.log('done updates')
    );
    }





}


// Allows formatting of dates etc...
// export class DatePipeComponent {
//   today: number = Date.now();
//   fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
//   // tslint:disable-next-line:eofline
// }
